import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ScullyRoutesService } from '@scullyio/ng-lib';
import { combineLatest } from 'rxjs';
import { map, pluck } from 'rxjs/operators';
import { SEOService } from '../../services/seo.service';

@Component({
  selector: 'app-in-evidenza-post',
  templateUrl: './in-evidenza-post.component.html',
  styleUrls: ['./in-evidenza-post.component.scss']
})
export class InEvidenzaPostComponent implements OnInit {

  pageTitle = "Leone Lifestyle";
  desc = "La nuova era della nutrizione e del benessere";
  shareImg = "in-evidenza/";

  constructor(
    private activatedRoute: ActivatedRoute,
    private scully: ScullyRoutesService,
    private seo: SEOService
  ) {}

  $blogPostMetadata = combineLatest([
    this.activatedRoute.params.pipe(pluck('inEvidenzaId')),
    this.scully.available$
  ]).pipe(
    map(([inEvidenzaId, routes]) =>
      routes.find(route => route.route === `/in-evidenza/${inEvidenzaId}`)
    )
  );

  blog$ = this.scully.getCurrent();

  ngOnInit(): void {
    this.blog$.subscribe((b) => {
      this.seo.updatePageTags(b.pageTitle + " | " + this.pageTitle, this.desc, this.shareImg + b.shareImg);
    });
  }
}
